import { render, staticRenderFns } from "./TopicKnowledgePanel.vue?vue&type=template&id=cf76dcae&scoped=true"
import script from "./TopicKnowledgePanel.vue?vue&type=script&lang=js"
export * from "./TopicKnowledgePanel.vue?vue&type=script&lang=js"
import style0 from "./TopicKnowledgePanel.vue?vue&type=style&index=0&id=cf76dcae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf76dcae",
  null
  
)

export default component.exports